<template>
  <div class="app">
    
    <Header v-if="isLoggedIn && $route.path !== '/login'"/>
    <div class="app__container">
      <Sidebar v-if="isLoggedIn && $route.path !== '/login'"/>
      
      <main 
        class="app__main"
        :class="{
          'app__main--collapsed': appStore.isSidebarCollapsed,
          'app__main--mobile-sidebar-open': appStore.isMobileSidebarOpen
        }"
      >
      
        <div class="app__content">
          <router-view />
        </div>
      </main>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useAuthStore,useAppStore } from './stores/auth'
import Sidebar from './components/SidebarConfig.vue'
import Header from './components/HeadertoConfig.vue'
const authStore = useAuthStore()
const isLoggedIn = computed(() => authStore.isLoggedIn)
// const isCollapse = ref(false)

// const sidebarWidth = computed(() => {
//   return isCollapse.value ? '64px' : '200px'
// })
const appStore = useAppStore()
// const handleToggleCollapse = () => {
  
//   isCollapse.value = toggleCollapse.isCollapse
// }
</script>


<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  background-color: #f8f9fa;
  color: #333;
  height: 100vh;
  margin: 0;
  padding: 0;
  
}

html {
  height: 100vh;

}

.app {
  height: 100vh;
  display: flex;
  flex-direction: column;

}

.app__container {
  flex: 1;
  display: flex;
  height: calc(100vh - 60px);
  
}

.app__main {
  flex: 1;
  margin-left: 220px;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  width: calc(100% - 220px);
  box-sizing: border-box;
  height: 100%;
 
}

.app__main--collapsed {
  margin-left: 70px;
  width: calc(100% - 70px);
}

.app__content {
  flex: 1;

  height: 100%;
  padding: 20px;
  display: flex;
  flex-direction: column;
}

/* 强制所有表格可以滚动 - 全局样式 */




/* 滚动条样式保持不变 */
::-webkit-scrollbar {
  width: 12px;
  height: 12px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 6px;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 6px;
  border: 2px solid #f1f1f1;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.el-table__body-wrapper::-webkit-scrollbar {
  width: 12px;
  height: 12px;
}

.el-table__body-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 6px;
}

.el-table__body-wrapper::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 6px;
  border: 2px solid #f1f1f1;
}

.el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.el-table__body-wrapper {
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 #f1f1f1;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .app__main {
    margin-left: 0 !important;
  }

  .app__main--mobile-sidebar-open {
    transform: translateX(220px);
  }

  .app__content {
    padding: 5px;
    
  }
}

.supplier-page, .customer-page {
  
  height: auto !important;
}

</style>